import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import HierarchicalListNode from '..';
import { getLightBorder } from 'Components/utils';
import classNames from 'classnames';
import ListItem from './ListItem';

const useStyles = buildUseStyles('HierarchicalListNodeContent', ((theme) => ({
  root: {},
  listContainer: {
    display: 'flex',
  },
  listItemContainer: {
    paddingTop: theme.spacing(2),
  },
  listItemBefore: {
    width: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  listItemBeforeTop: {
    flexGrow: 1,
    ...getLightBorder(theme, { left: true, bottom: true }),
  },
  listItemBeforeBottom: {
    flexGrow: 1,
  },
  childrenContainer: {
    paddingLeft: theme.spacing(2),
  },
  children: {
    position: 'relative',
    paddingLeft: theme.spacing(2),
  },
  child: {
    display: 'flex',
    position: 'relative',
    '&:not(:last-child)': {
      '&:before': {
        content: "''",
        zIndex: 1,
        position: 'absolute',
        transform: 'translateX(-100%)',
        top: 0,
        left: '1px',
        height: '100%',
        ...getLightBorder(theme, { left: true }),
      },
    },
  },
  hidden: {
    display: 'none',
  },
})));

const HierarchicalListNodeContent = ({
  resource,
  isChild,
  onClickItem,
}) => {
  const classes = useStyles();
  const { relationshipCollection } = useIncludedRelationshipContext();

  return (
    <Box
      className={classes.root}
    >
      <Box className={classes.listContainer}>
        <Box className={classNames(classes.listItemBefore, {
          [classes.hidden]: !isChild,
        })}
        >
          <Box className={classes.listItemBeforeTop} />
          <Box className={classes.listItemBeforeBottom} />
        </Box>
        <Box
          className={classes.listItemContainer}
        >
          <ListItem
            resource={resource}
            onClickItem={onClickItem}
          />
        </Box>
      </Box>
      <div className={classes.childrenContainer}>
        <div
          className={classes.children}
        >
          {relationshipCollection.resources().list().map((relationshipResource) => {
            return (
              <Box
                className={classes.child}
                key={relationshipResource.id()}
              >
                <HierarchicalListNode
                  isChild
                  resource={relationshipResource}
                  onClickItem={onClickItem}
                />
              </Box>
            );
          })}
        </div>
      </div>
    </Box>
  );
};

HierarchicalListNodeContent.defaultProps = {
  onClickItem: null,
};

HierarchicalListNodeContent.propTypes = {
  resource: PropTypes.object.isRequired,
  isChild: PropTypes.bool.isRequired,
  onClickItem: PropTypes.func,
};

export default HierarchicalListNodeContent;
